// extracted by mini-css-extract-plugin
export default {"input":"Addon_input__eeH+b","inner":"Addon_inner__NoaEQ"};